import classNames from 'classnames'
import React, { cloneElement, useRef, useState } from 'react'
import { ITooltip } from './interface'
import './Tooltip.scss'

export const Tooltip = ({ children, content, subtitle, title, withoutBorder = false }: ITooltip): JSX.Element => {
  const [isActive, setActive] = useState(false)
  const childrenRef = useRef(null)

  if (!children || !(children as any)?.props) {
    return <></>
  }

  const childrenProps: any = (children as any)?.props

  const onClick = (evt: any) => {
    setActive(true)
    childrenProps?.onClick?.(evt)
  }

  const onMouseEnter = (evt: any) => {
    setActive(true)
    childrenProps?.onMouseEnter?.(evt)
  }

  const onMouseLeave = (evt: any) => {
    setActive(false)
    childrenProps?.onMouseLeave?.(evt)
  }

  const newChildrenProps = {
    ref: (childRef: any) => {
      childrenRef.current = childRef
    },
    ...((children as any).props ?? {}),
    onClick,
    onMouseEnter,
    onMouseLeave
  }

  return (
    <>
      {cloneElement(children as any, newChildrenProps)}
      {isActive && (
        <div className='tooltip'>
          <div className='tooltip-inner'>
            <div className='tooltip-close'>
              <i className='icon-close' onClick={(): void => setActive(false)} />
            </div>
            <div className='tooltip-header'>
              <div className={classNames('tooltip-header-title', { withoutSubtitle: !subtitle })}>{title}</div>
              <div className='tooltip-header-subtitle'>{subtitle}</div>
            </div>
            <div className={classNames('tooltip-content', { withoutBorder })}>{content}</div>
          </div>
        </div>
      )}
    </>
  )
}
